export default __webpack_public_path__ + "static/media/appstore.92cebc7b.svg";